<template>
  <el-form label-position="top" :model="form" :rules="rules" ref="form_create">
    <!-- <h1 class="title">Nueva categoría de documento</h1> -->
    <el-form-item
      style="margin-top: 20px; font-weight: bold"
      label="Nombre"
      prop="Name"
    >
      <el-input
        v-model="form.Name"
        placeholder="Escribir el nombre de la categoría"
        class="fields"
      ></el-input>
    </el-form-item>
    <el-form-item
      style="margin-top: 10px; font-weight: bold"
      label="Lista Maestra"
    >
      <el-select
        v-model="form.ISODocumentMasterListId"
        placeholder="Seleccione una lista maestra"
        filterable
        class="fields"
      >
        <el-option
          v-for="item in MasterList"
          :key="item.Id"
          :value="item.Id"
          :label="item.Name"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item style="margin-top: 10px; font-weight: bold" label="Proceso">
      <el-select
        v-model="form.ISODocumentProcessId"
        placeholder="Seleccione un proceso"
        filterable
        class="fields"
      >
        <el-option
          v-for="item in ProcessList"
          :key="item.Id"
          :value="item.Id"
          :label="item.Name"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      style="margin-top: 10px; font-weight: bold"
      label="Revisado por"
    >
      <el-select
        v-model="form.ShouldBeRevisedById"
        placeholder="Seleccione un responsable"
        filterable
        class="fields"
      >
        <el-option
          v-for="item in Users"
          :key="item.Id"
          :value="item.Id"
          :label="item.Name"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      style="margin-top: 10px; font-weight: bold"
      label="Aprobado por"
    >
      <el-select
        v-model="form.ShouldBeApprovedById"
        placeholder="Seleccione un responsable"
        filterable
        class="fields"
      >
        <el-option
          v-for="item in Users"
          :key="item.Id"
          :value="item.Id"
          :label="item.Name"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      style="margin-top: 10px; font-weight: bold"
      label="Plantillas"
    >
      <el-select
        v-model="form.Template"
        placeholder="Seleccione una plantilla"
        filterable
        class="fields"
      >
        <el-option
          v-for="dep in Plantillas"
          :key="dep.Id"
          :value="dep.Id"
          :label="dep.Name"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      style="margin-top: 10px; font-weight: bold"
      label="Tipo de documentos"
    >
      <el-select
        v-model="form.DocumentType"
        placeholder="Seleccione un tipo"
        filterable
        class="fields"
      >
        <el-option
          v-for="dep in DocumentType"
          :key="dep.Id"
          :value="dep.Id"
          :label="dep.Name"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-button @click="onCancel">Cancel</el-button>
    <el-button @click="saveCategories" type="primary">Guardar</el-button>
  </el-form>
</template>
<script>
export default {
  name: "NewCategories",
  props: {
    Visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        Name: "",
        ISODocumentMasterListId: "",
        ISODocumentProcessId: "",
        ShouldBeRevisedById: "",
        ShouldBeApprovedById: "",
        Template: "",
        DocumentType: ""
      },
      rules: {
        Name: [{ required: true, trigger: "blur", message: "Requerido" }]
      },
      categoriesValue: [],
      Users: [],
      MasterList: [],
      ProcessList: [],
      Plantillas: [
        { Id: "NoTemplate", Name: "Sin Plantilla" },
        { Id: "Procedure", Name: "Procedimiento" },
        { Id: "WorkInstruction", Name: "Instruccion de Trabajo" },
        { Id: "Norm", Name: "Normas" }
      ],
      DocumentType: [
        { Id: "Form", Name: "Formulario" },
        { Id: "Procedure", Name: "Procedimiento" },
        { Id: "WorkInstruction", Name: "Instruccion de Trabajo" },
        { Id: "Norm", Name: "Normas" },
        { Id: "Document", Name: "Documento" }
      ]
    };
  },
  methods: {
    onCancel() {
      this.form = {};
      this.legal_visible = false;
      this.$refs.form_create.resetFields();
      this.$emit("dialog-closed");
    },
    getCategories() {
      this.$http
        .get("/api/ISODocumentCategory")
        .then((resp) => {
          const IsoCat = resp.data.Items.map((i) => {
            return { ID: i.Id, Name: i.Name };
          });
          this.categoriesValue = IsoCat;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getUsers() {
      this.$http
        .get("/api/users")
        .then((resp) => {
          const userList = resp.data.map((i) => {
            return { Id: i.Id, Name: i.FirstName + " " + i.LastName };
          });
          this.Users = userList;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getDocumentProcess() {
      this.$http
        .get("/api/ISODocumentCategory/ISODocumentProcesses")
        .then((resp) => {
          const processList = resp.data.map((i) => {
            return { Id: i.Id, Name: i.Name };
          });
          this.ProcessList = processList;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getMasterList() {
      this.$http
        .get("/api/ISODocumentCategory/ISODocumentMasterList")
        .then((resp) => {
          const masterList = resp.data.map((i) => {
            return { Id: i.Id, Name: i.Name };
          });
          this.MasterList = masterList;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    saveCategories() {
      this.$refs.form_create.validate((valid) => {
        if (valid) {
          this.$http
            .post("/api/ISODocumentCategory", this.form)
            .then(() => {
              this.form = {};
              this.$refs.form_create.resetFields();
              this.$message({
                type: "success",
                message: "Registro de categoría exitoso"
              });
              this.$emit("dialog:closed");
            })
            .catch((err) => {
              this.$message({ type: "error", message: err.message });
            });
          this.$emit("refresh-table");
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    this.getCategories();
    this.getUsers();
    this.getDocumentProcess();
    this.getMasterList();
  }
};
</script>
<style scoped>
.title {
  /* Nuevo Documento */

  position: absolute;
  width: auto;
  height: 19px;

  margin-left: 20%;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 19px;
  /* identical to box height */

  color: #2484c4;
}

label .el-form-item__label {
  /* Adjuntar documento */

  width: 188px;
  height: 18px;

  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;

  color: #3c3c3c;
}

label {
  color: #bf3636;
  margin-top: 5px;
  margin-bottom: 5px;
}
ul > li > label > .el-upload-list--picture .el-upload-list__item-status-label {
  position: absolute;
  right: -17px;
  top: -7px;
  width: 46px;
  height: 26px;
  background: #5f8fdf;
  text-align: center;
  transform: rotate(45deg);
  box-shadow: 0 1px 1px #ccc;
}
.fields {
  width: 400px;
  margin-left: 5%;
}
</style>
